import { IDLE_PROMPT_TIMEOUT } from 'constants/messages.constant';

import { useTimer } from 'react-timer-hook';
import { padToTwo } from 'utils';

const Timer = () => {
  let time = new Date();

  time.setSeconds(time.getSeconds() + IDLE_PROMPT_TIMEOUT / 1000);

  const { seconds, minutes } = useTimer({
    expiryTimestamp: time,
    onExpire: () => null,
  });
  return (
    <h2 className='text-center'>{`${padToTwo(minutes)}:${padToTwo(
      seconds
    )}`}</h2>
  );
};

export default Timer;
